// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"94":"Login","237":"StationScreen","380":"WindHome","684":"Admin","736":"ActualPower","779":"SolarHome"}[chunkId] + "." + {"94":"23c15777","237":"d2953b22","380":"fc3c0885","684":"105c2dab","736":"fe1f32ca","779":"a716a7e3"}[chunkId] + ".css";
};